module.exports = __webpack_public_path__ + "img/pending_video.f13d9ef5.png";